<template>
    <div class="product-variations">
        <div class="variation-wrap" v-if="variations && variations.length">
            <span>{{ title }}:</span>
            <div class="wrap">
                <div class="variation"
                     v-for="(variation, key) in variations"
                     :key="key"
                     :class="'variation-'+ variation.product_id"
                     @click="handleClick(variation, true)"
                >
                    {{ variation.option_value }} {{ variation.option_value_mu }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { inject, onMounted } from 'vue'
import { useUrlParams } from '../../composables/useUrlParams'

export default {

    props: [
        'variations',
        'title'
    ],

    setup(props) {

        const emitter = inject('emitter')

        const { url } = useUrlParams()

        onMounted( () => {
            console.log(props.variations)
            let urlId = url.searchParams.get('id')

            if ( urlId ) setByUrl(urlId)
            else {
                setUrl(props.variations[0].product_id)
                setTimeout( () => {
                    emitter.emit('on-variation-set', props.variations[0])
                }, 250)
            }
        })

        function setUrl(value) {
            url.searchParams.set('id', value)
            window.history.replaceState(null, '', url)

            handleClick(props.variations[0])
        }

        function setByUrl(value) {
            let variation = props.variations.find( item => item.product_id === parseInt(value))

            setTimeout( () => {
                emitter.emit('on-variation-set', variation)
            }, 250)

            handleClick(variation)
        }

        function handleClick(variation, shouldSetUrl = false) {
            let variations = document.querySelectorAll('.product-variations .variation')

            variations.forEach( (sizeLoop, index) => {
                if ( sizeLoop.classList.contains(`variation-${variation.product_id}`) )
                    sizeLoop.classList.add('active')
                else
                    sizeLoop.classList.remove('active')
            })

            if ( shouldSetUrl ) {
                url.searchParams.set('id', variation.product_id)
                window.history.replaceState(null, '', url)
            }

            setTimeout( () => {
                emitter.emit('on-variation-set', variation)
            }, 50)
        }

        return {
            handleClick,
        }
    }
}
</script>
